export const getRadianByValue = (nvalue: number, openingRadian: number, max: number, min: number) => {
    'worklet';
    return ((Math.PI - openingRadian) * 2 * (max - nvalue)) / (max - min) + openingRadian;
};

// Converts polar coordinates (angle, radius) to Cartesian coordinates (x, y)
export const polarToCartesian = (radian: number, radius: number, centerOffset: number) => {
    'worklet';
    const calculatedRadian = radian + Math.PI;
    const x = centerOffset + radius * Math.sin(calculatedRadian);
    const y = centerOffset + radius * Math.cos(calculatedRadian);

    return { x, y };
};

// Converts Cartesian coordinates (x, y) to polar radians
export const cartesianToPolar = (x: number, y: number, centerOffset: number) => {
    'worklet';
    const TWO_PI = 2 * Math.PI;

    // Calculate the angle from center (note swapped y,x for clockwise direction)
    const angleFromCenter = Math.atan2(y - centerOffset, x - centerOffset);

    // Calculate difference with top position (270° in standard coordinates, or 3π/2)
    // When using atan2, top is 3π/2 or -π/2 depending on coordinate system
    let result = (Math.PI * 1.5 - angleFromCenter) % TWO_PI;

    // Ensure the result is positive
    if (result < 0) {
        result += TWO_PI;
    }

    return result;
};

export const getCurrentRadian = (value: number, openingRadian: number, max: number, min: number) => {
    return getRadianByValue(value, openingRadian, max, min);
};
